export default {
  settingsTitle: "Настройки ЭДО",
  rentDocuments: "Обмениваться закрывающими документами по аренде площади",
  servicesDocuments: "Обмениваться закрывающими документами по заказам услуг",
  updateSuccess: "Настройки ЭДО успешно обновлены",
  updateError: "Ошибка при обновлении настроек ЭДО",
  contractEdoEnabled: "ЭДО включено для договора",
  contractEdoDisabled: "ЭДО отключено для договора",
  contractUpdateError: "Ошибка при обновлении ЭДО договора",
  invitationNotice:
    "Если Вы хотите получать закрывающие документы в системе ЭДО, направьте нам приглашение:",
  companyInfo: "АО «ЭКСПОЦЕНТР», ИНН 7718033809",
  edoIdLabel: "Идентификационный номер в системе ЭДО:",
  edoId: "2BM-7718033809-770301001-201411210937282283051",
  legalDescription:
    "Электронный документ, заверенный квалифицированной электронной подписью в рамках системы ЭДО Контур.Диадок, обладает юридической силой оригинального документа. Оформление бумажной копии закрывающих документов не требуется."
};
